/**
 * 인버터 현재출력 비율 % (출력 ÷ 모듈용량 × 100) — 구앱 `calculateInverterPowerRatio` 정합.
 *
 * 대시보드 인버터 목록·발전량 조회조건의 인버터 선택이 같은 값을 쓰므로 shared 에 둔다(양쪽이 각자
 * 구현하던 시절 한쪽이 `Math.abs` 로 부호를 삼켜 값이 갈렸다 — 구앱은 **부호를 유지**한다).
 *
 * - 용량 0/음수 → 0 (0 나눗셈 방어)
 * - |값| < 0.1 → 0 (미세 잔여 출력을 0 으로 수렴시키는 구앱 규칙)
 * - 그 외는 **부호 그대로** — 야간 역조류 등 음수 출력을 숨기지 않는다. 표시 폭이 0~100 인 `PowerBar` 는
 *   자체적으로 clamp 하므로 게이지는 안전하고, 숫자는 음수로 보이는 게 사실에 맞다.
 */
export function inverterPowerPercent(power: number | null, moduleCapacity: number): number {
  if (moduleCapacity <= 0) return 0;
  const value = ((power ?? 0) / moduleCapacity) * 100;
  return Math.abs(value) < 0.1 ? 0 : value;
}
